<div class="tw:flex tw:justify-start tw:gap-2">
    @for (tab of tabOptions; let i = $index; track i) {
        <button
            type="button"
            class="btn btn-md"
            [class.tw:px-4]="size === 'sm' || size === 'md'"
            [class.tw:py-2]="size === 'sm' || size === 'md'"
            [class.tw:!text-[14px]]="size === 'sm' || size === 'md'"
            [class.tw:md:text-base]="size === 'md'"
            [class.tw:md:px-6]="size === 'md'"
            [class.tw:md:py-3]="size === 'md'"
            [class.btn-primary]="activeTab() === tab.value"
            [class.btn-secondary]="activeTab() !== tab.value"
            (click)="changeTab(tab.value)"
        >
            {{ tab.label }}
        </button>
    }
</div>
